import React from 'react'
import Form from 'react-bootstrap/Form';
import UiTopInputElementsWr from "../../components/common/UiTopInputElementsWr"
import PropTypes from 'prop-types';

export default function UiTopInput(props) {

    return (
        <>
            <UiTopInputElementsWr>
                <label htmlFor={props.label}>
                    {props.label}</label>
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder={props.placeholder}
                        value={props.value}
                        id={props.label}
                        
                    />
                     <Form.Control.Feedback type={props.errorType}>
                        {props.errorMsg}
                    </Form.Control.Feedback>
                </Form.Group>
            </UiTopInputElementsWr>

        </>
    )
}

UiTopInput.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    errorType: PropTypes.string,
    errorMsg: PropTypes.string,
};